/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateCountryLangRequestViewModel } from "../types/CreateCountryLangRequestViewModel.ts";

export const createCountryLangRequestViewModelSchema = z.object({
  cultureInfo: z.string().nullish(),
  name: z.string().nullish(),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<CreateCountryLangRequestViewModel>;
